import { render, staticRenderFns } from "./AutomationKnowledgeMenu.vue?vue&type=template&id=04c84b26&"
import script from "./AutomationKnowledgeMenu.vue?vue&type=script&lang=js&"
export * from "./AutomationKnowledgeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports